<template>
  <section
    class="why-grid"
    :class="[{ dark: tone === 'dark' }, 'why-grid--' + tone]"
    :id="blockId || undefined"
  >
    <div class="container">
      <section-title data-aos="fade-up" :kicker="kicker" :title="title" :lede="lede" :tone="tone" />

      <panel-list layout="cards" :tone="tone" stacked :columns="columns" :items="items" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

/* Two grounds, one band.

   The dark ground is the default and is not declared here: it comes from the
   global `section.dark` class in _base.scss, exactly as it always did, so every
   existing caller is unchanged.

   The light tone paints the white ground from the component, the way FaqList
   declares its own. It exists because a page can need this band directly above
   a dark quote band, and two dark slabs meeting is not a layout the site has
   anywhere else. White rather than $ground-tint, because the band above it on
   that page is already the tint, and the alternation is the point. */
.why-grid--light {
  background: $ground;
}
</style>

<script>
import PanelList from '@/Components/PanelList.vue';
import SectionTitle from '@/Components/SectionTitle.vue';

/* The grid of cards is PanelList now. It was the same translucent dark card,
   the same hairline beam, the same 2.4rem primary tile and the same lift as six
   other panels on the site, so the panel owns that anatomy. The space between
   the section title and the cards comes from the title's own bottom margin. */
export default {
  components: {
    PanelList,
    SectionTitle
  },

  props: {
    title: {
      type: String,
      required: true
    },
    kicker: {
      type: String,
      default: ''
    },
    lede: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    /* Card columns at 768px and up. */
    columns: {
      type: Number,
      default: 2
    },
    /* dark | light. The title and the cards follow the same tone, so the band
       is one ground rather than a light heading over dark panels. */
    tone: {
      type: String,
      default: 'dark',
      validator: (value) => ['dark', 'light'].includes(value)
    },
    blockId: {
      type: String,
      default: ''
    }
  }
};
</script>
